import {Pipe, PipeTransform} from '@angular/core';
import {CurrencyPipe} from '@angular/common';

@Pipe({
    name: 'indianCurrency'
})
export class IndianCurrencyPipe extends CurrencyPipe implements PipeTransform {

    transform(value: any): string | null {
        return super.transform(value, 'INR', 'symbol', '1.0-2', 'en-IN');
    }
}
